<template>
  <div>
    <b-overlay :show="loading">
      <b-container fluid>
        <span 
          v-if="etapyDvigeniya"
          @click="visible = 'etapy'"
          :class="visible === 'etapy' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Этапы движения</span>
      </b-container>

      <div v-show="visible === 'etapy'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Маршрут</label>
                  </b-col>
                  <b-col sm="10">
                    <b-list-group horizontal="md" class="d-flex">
                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['pogruzka_gruza_plan'], editedData['pogruzka_gruza_fact'])">
                        <div>
                          <span class="small-description">адрес погрузки</span>
                          {{ editedData.naselenniy_punkt || '<Здесь будет населенный пункт>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['pogruzka_gruza_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['pogruzka_gruza_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['pribitie_na_pp_plan'], editedData['pribitie_na_pp_fact'])">
                        <div>
                          <span class="small-description">погран переход</span>
                          {{ nameByPropId(editedData.pogran_perehod_id) || '<Здесь будет погран переход>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['pribitie_na_pp_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['pribitie_na_pp_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['pribitie_na_svh_plan'], editedData['pribitie_na_svh_fact'])">
                        <div>
                          <span class="small-description">СВХ станция прибытия</span>
                          {{ nameByPropId(editedData.svh_id) || '<Здесь будет СВХ станция прибытия>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['pribitie_na_svh_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['pribitie_na_svh_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['dostavka_plan'], editedData['dostavka_fact'])">
                        <div>
                          <span class="small-description">адрес разгрузки</span>
                          {{ editedData.address_of_unloading_town || '<Здесь будет адрес разгрузки>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['dostavka_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['dostavka_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>
                    </b-list-group>                   
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import {
  constantsAllReferenceProperties,
  dateHelpers,
  dataHelpers
} from '@/mixins';

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    saveMode: {
      type: Boolean,
      default: false,
    },
    detailedItem: {
      type: Object,
      required: true,
    },
    filteredDocs: {
      type: Array,
      required: true,
    },
    etapyDvigeniya: {
      type: Boolean,
      default: true,
    },
    defaultVisible: {
      type: String,
      default: 'etapy',
    },
  },
  mixins: [
    constantsAllReferenceProperties,
    dateHelpers,
    dataHelpers
  ],
  components: {},
  computed: {
    transitnoe_vremya() {
      if (!this.editedData['pribitie_na_svh_fact'] || !this.editedData['pogruzka_gruza_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['pogruzka_gruza_fact'], this.editedData['pribitie_na_svh_fact']);
      return transitnoe_vremya;      
    },
    time_of_to() {
      if (!this.editedData['vypusk_dt_fact'] || !this.editedData['podacha_dt_fact']) {
        // return 'Заполните поля <Выпуск ДТ> и <Подача ДТ>';
        return "<Расчет недоступен>";
      } 

      const time_of_to = this.getDiffNumberOfDays(this.editedData['podacha_dt_fact'], this.editedData['vypusk_dt_fact']);
      return time_of_to;
    },
    obshee_transitnoe_vremya() {
      if (!this.editedData['pogruzka_gruza_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['pogruzka_gruza_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya;      
    }
  },
  watch: {
    transitnoe_vremya(value) {
      this.editedData['transitnoe_vremya'] = value;
    },
    time_of_to(value) {
      this.editedData['time_of_to'] = value;
    },
    obshee_transitnoe_vremya(value) {
      this.editedData['obshee_transitnoe_vremya'] = value;
    }
  },
  data() {
    return {
      loading: false,
      localEditMode: false,
      visible: 'etapy',
      editedData: {
        "0": { value: '' },
        "1": { value: '' },
        name_of_cargo: '',
        import_export: 'Импорт',
        usloviya_postavki_id: null,
        naselenniy_punkt: '',
        cargo_sender_name: '',
        address_g_o: '',
        mesto_pogruzki_strana: '',
        mesto_pogruzki_gorod: '',
        contact_name_on_shipment: '',
        cargo_recipient_company_id: null,
        inn_g_p: '',
        kpp_g_p: '',
        address_g_p: '',
        address_of_unloading_town: '',
        address_of_unloading_street: '',
        contact_name_on_unloading: '',
        svh_id: null,
        svh_full_address: '',

        perevozchik_id: null,
        perevozchik_name: '',
        perevozchik_inn: '',
        perevozchik_uridicheskiy_address: '',

        pogran_perehod_id: null,

        number_of_auto: 1,

        transports: [
          {
            nomer_of_tyagach: '',
            nomer_of_pricep: '',
            number_of_places: 0,
            weight: 0,
            volume: 0,
            type_of_auto_id: null,
            volume_of_auto: 0,    // Не для Сборки (тип авто)
            temp_of_auto_min: '',  // Только для Рефриджераторов (тип авто)
            temp_of_auto_max: '',  // Только для Рефриджераторов (тип авто)
            cmrs: [
              {
                nomer_of_cmr: '',
                data_pogruzki_cmr: '',
              }
            ]
          }
        ],

        gotovnost_gruza_plan: '',
        gotovnost_gruza_fact: '',
        pogruzka_gruza_plan: '',
        pogruzka_gruza_fact: '',
        pribitie_na_pp_plan: '',
        pribitie_na_pp_fact: '', 
        vyhod_s_pp_plan: '',
        vyhod_s_pp_fact: '',
        pribitie_na_svh_plan: '',
        pribitie_na_svh_fact: '',
        transitnoe_vremya: '',

        zakritie_dostavki_plan: '',
        zakritie_dostavki_fact: '',
        podacha_dt_plan: '',
        podacha_dt_fact: '',
        vypusk_dt_plan: '',
        vypusk_dt_fact: '',
        time_of_to: '',

        dostavka_plan: '',
        dostavka_fact: '',
        obshee_transitnoe_vremya: ''
      },
    };
  },
  watch: {
    editMode: {
      handler(value) {
        this.localEditMode = value;
      },
      immediate: true
    },
    saveMode: {
      handler(value) {
        if (value == true) {
          this.$emit('updateData', this.editedData);
        }
      },
      immediate: true
    },
    detailedItem: {
      handler(data) {
        this.editedData = this.deepMergeSafeFirst(JSON.parse(JSON.stringify(data.data)), JSON.parse(JSON.stringify(this.editedData)));
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {
    this.visible = this.defaultVisible;
  },
  methods: {
    setReferenceValue(value, reference_id, index) {
      let indexArray = index.split('.');
      if (indexArray.length > 1) {
        if (indexArray[0] == 'transports') {
          if (indexArray[2] != 'cmrs') {
            this.editedData[indexArray[0]][indexArray[1]][indexArray[2]] = value;  
          }
        }
      } else {
        this.editedData[index] = value;
      }
    }, 
    setCompanyRecipientOfOrder(value, element) {
      this.editedData['cargo_recipient_company_id'] = value;
      this.editedData['inn_g_p'] = element.inn;
      this.editedData['kpp_g_p'] = element.kpp;
      this.editedData['address_g_p'] = element.address;
    },
    setCompanyPerevozchikOfOrder(value, element) {
      this.editedData['perevozchik_id'] = value;
      this.editedData['perevozchik_name'] = element.name;
      this.editedData['perevozchik_inn'] = element.inn;
      this.editedData['perevozchik_uridicheskiy_address'] = element.address;
    },
    changeSelectedDoc(doc) {
      this.editedData[0].value = doc.name;
      this.editedData[1].value = doc.date_of_document;
    },    
    addTs() {
      let prevTS = this.editedData['transports'][this.editedData['transports'].length - 1];
      this.editedData['transports'].push(JSON.parse(JSON.stringify(prevTS)));
      this.editedData['number_of_auto']++;
    },
    deleteTs(ts_index) {
      this.editedData['transports'].splice(ts_index, 1);
      this.editedData['number_of_auto']--;
    },
    addCMR(ts_index) {
      let prevCMR = this.editedData['transports'][ts_index]['cmrs'][this.editedData['transports'][ts_index]['cmrs'].length - 1];
      this.editedData['transports'][ts_index]['cmrs'].push(JSON.parse(JSON.stringify(prevCMR)));
    },
    deleteCMR(ts_index, cmr_index) {
      this.editedData['transports'][ts_index]['cmrs'].splice(cmr_index, 1);
    },

  },
};
</script>
<style scoped>
.one-transport {
  background: #f2f2f2;
  border: 1px dashed #0d6247;
}

.one-cmr {
  border-left: 1px solid #CCC;
}
.one-cmr:hover {
  border-left: 1px solid #0d6247;
}
.delete-one-cmr {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 18px;
  left: -45px;
}
.custom-select {
  height: 34px !important;
  border-radius: 3px !important;
  padding: 1px 8px;
}
.small-description {
  line-height: 11px;
}

.b-group-item-end {
  display: flex !important;
  justify-content: space-between !important;
}

.b-group-item-end b {
  text-transform: none;
}
</style>